import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA01Atz44VIFIlvV155x_q1CXMDx16baU4",
  authDomain: "finance-tracker-15143.firebaseapp.com",
  projectId: "finance-tracker-15143",
  storageBucket: "finance-tracker-15143.firebasestorage.app",
  messagingSenderId: "1039819450169",
  appId: "1:1039819450169:web:b0f0162301d60da7122ae8",
  measurementId: "G-SC2PZSRJZF"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);